import { ComponentType } from 'react';
import { DialogsPage } from '../dialogs';

export const Instructions: ComponentType = () => {
  return <DialogsPage />;
};
